export default 'https://tme.understood.org/assets/global_outro.en.4ab06563.vtt'